import React from 'react';
import { RegisterModuleStateProps } from '@/components/modules/register/register-dynamic/types';
import { useFlutterEvents } from '@/components/utils/hooks/events/useFlutterEvents';
import { GLOBAL_FLUTTER_CHANNELS, REGISTER_EVENTS } from '@/components/utils/hooks/events/constants';
import { useAppDispatch, useAppSelector } from '@/store';
import MarketingEvents from '@/utils/marketing/MarketingEvents';
import { getShortLiveToken } from '@/modules/casino/store/actions/login';

export function useRegisterEvents(state: RegisterModuleStateProps) {
  const events = useFlutterEvents();
  const dispatch = useAppDispatch();

  const { signedUp, signUpLoading } = useAppSelector((state) => state.register);
  const { client_player_id } = useAppSelector<any>((state) => state.profile);
  const { shortLiveToken } = useAppSelector((state) => state.login);

  React.useEffect(() => {
    events.send(GLOBAL_FLUTTER_CHANNELS.POKER_APP_EVENT, {
      event: REGISTER_EVENTS.FORM_READY,
    });

    return () => {
      events.send(GLOBAL_FLUTTER_CHANNELS.POKER_APP_EVENT, {
        event: REGISTER_EVENTS.FORM_CLOSE,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (signUpLoading) {
      events.send(GLOBAL_FLUTTER_CHANNELS.POKER_APP_EVENT, {
        event: REGISTER_EVENTS.FORM_SUBMIT,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signUpLoading]);

  React.useEffect(() => {
    if (state.errors.global) {
      events.send(GLOBAL_FLUTTER_CHANNELS.POKER_APP_EVENT, {
        event: REGISTER_EVENTS.SERVER_OR_NETWORK_ERROR,
        payload: {
          message: state.errors.global,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.errors.global]);

  React.useEffect(() => {
    if (state.OCRModalOpen) {
      events.send(GLOBAL_FLUTTER_CHANNELS.POKER_APP_EVENT, {
        event: REGISTER_EVENTS.FORM_UPLOAD_DOCUMENT,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.OCRModalOpen]);

  React.useEffect(() => {
    if (signedUp) {
      if (window.config.appEnv === 'poker') {
        dispatch(getShortLiveToken());
      }
      MarketingEvents.signUpCompleted({ playerId: client_player_id });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client_player_id]);

  React.useEffect(() => {
    if (signedUp && client_player_id && shortLiveToken) {
      events.send(GLOBAL_FLUTTER_CHANNELS.POKER_APP_EVENT, {
        event: REGISTER_EVENTS.AUTO_LOGIN,
        payload: {
          token: shortLiveToken,
        },
      });
    }
  });

  return null;
}